export class AuthStateModel {
    token?: string;
    username?: string;
    refresh_token?: string;
    expires_at?: number;
    authenticated?: boolean;
}

export class Login {
    static readonly type = '[Auth] Login';
    constructor(public payload: any) { }
}

export class Logout {
    static readonly type = '[Auth] Logout';
}

export class RefreshToken {
    static readonly type = '[Auth] RefreshToken';
}
